<template>
 <div class="eating-body">
   <img src="@/assets/eating.png" />
 </div>
</template>

<script>
export default {
  created() {
    document.title='孟连牛油果吃法'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.eating-body {
  max-width: 750px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
}
.eating-body img {width: 100%}
</style>



// WEBPACK FOOTER //
// src/components/page/eating.vue